import request from 'helpers/request';
import api from 'config';

export const Add = (params) => {
  return request({
    url: api.config.companyAPI + '/addons/v1/favorite',
    method: 'post',
    data: params
  });
};

export const List = () =>
  request({
    url: api.config.companyAPI + '/addons/v1/favorite'
  });

export const Del = (code) => {
  return request({
    url: api.config.companyAPI + '/addons/v1/favorite/' + code,
    method: 'delete'
  });
};
